
<div class="bl-wrapper">
  <iframe
    class="bl-iframe"
    id="dashboardIframe"
    title="Analytics"
    allow="fullscreen"
  ></iframe>
</div>
